import { inject, Injectable } from '@angular/core';
import { Observable, of, ReplaySubject, switchMap } from 'rxjs';
import {
  ServiceProvisioningLevel,
  TileConfig,
  TileFieldConfigRequest,
} from '../../../shared/models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CiscoTileConfigContext {
  private _http = inject(HttpClient);

  private _baseUrl = '/services/cisco/field-configs/tile-configs';

  _stateSource = new ReplaySubject<TileConfig>(1);
  state$ = this._stateSource.asObservable();

  getTileConfigs(siteId: number, primaryExtension?: string): Observable<void> {
    if (siteId === -1) {
      const tileConfigForNoSite: TileConfig = {
        android: ServiceProvisioningLevel.SHOW,
        androidMobilityIdentity: ServiceProvisioningLevel.SHOW,
        cipc: ServiceProvisioningLevel.SHOW,
        deskphone: ServiceProvisioningLevel.SHOW,
        extensionMobility: ServiceProvisioningLevel.SHOW,
        imPresence: ServiceProvisioningLevel.SHOW,
        imSoftphone: ServiceProvisioningLevel.SHOW,
        iphone: ServiceProvisioningLevel.SHOW,
        iphoneMobilityIdentity: ServiceProvisioningLevel.SHOW,
        pcceAgent: ServiceProvisioningLevel.SHOW,
        primaryExtension: ServiceProvisioningLevel.SHOW,
        snrProfile: ServiceProvisioningLevel.SHOW,
        snrDestination: ServiceProvisioningLevel.SHOW,
        tablet: ServiceProvisioningLevel.SHOW,
        voicemail: ServiceProvisioningLevel.SHOW,
        voicemailAlternateExtension: ServiceProvisioningLevel.SHOW,
        webexCalling: ServiceProvisioningLevel.SHOW,
      };
      this._stateSource.next(tileConfigForNoSite);
      return of(null);
    } else {
      const request: TileFieldConfigRequest = {
        siteId: siteId,
        primaryExtension: primaryExtension ?? '',
      };
      return this._http.post<TileConfig>(this._baseUrl, request).pipe(
        switchMap((tileConfig) => {
          this._stateSource.next(tileConfig);
          return of(null);
        }),
      );
    }
  }
}
